<template>
  <v-card class="back pa-4 mt-0 report-card">
    <v-card-title class="d-flex justify-space-between"
      ><span
        >3.5 - {{ $t('Custo Evitado') }}
        <v-tooltip color="white" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="black" dark v-bind="attrs" v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span class="black--text">{{
            $t(
              'Apresenta o custo que seria acarretado à instituição caso não houvesse a intervenção da equipe de Engenharia Clínica presente no local.'
            )
          }}</span>
        </v-tooltip></span
      >
      <v-btn
        @click="requestExcel"
        depressed
        small
        class="secondary-button mr-1"
      >
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn></v-card-title
    >

    <v-divider class="mb-4"></v-divider>
    <strong class="pa-2">
      {{ $t('Valor total') }}: {{ total ? formatCurrency(total) : '' }}
    </strong>

    <v-alert type="error" class="mt-3 pa-0" v-if="costs.length == 0">
      Nenhum custo encontrado
    </v-alert>

    <v-simple-table v-else class="main-table" dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center"></th>
            <th class="text-center">O.S.</th>
            <th class="text-center">{{ $t('Setor') }}</th>
            <th class="text-center">{{ $t('Equipamento Padrão') }}</th>
            <th class="text-center">{{ $t('Descrição') }}</th>
            <th class="text-center">{{ $t('Custo') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cost in costs" :key="cost.costId">
            <td class="text-center"></td>
            <td class="text-center">{{ cost.osNumber }}</td>
            <td class="text-center">{{ cost.sector }}</td>
            <td class="text-center">{{ cost.standardEquipment }}</td>
            <td class="text-center">{{ cost.costDescription }}</td>
            <td class="text-center">{{ formatCurrency(cost.costValue) }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="pagination">
      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'

export default {
  name: 'AvoidedCosts',

  props: {
    filterProp: Object,
  },

  created() {
    this.list()
  },

  data() {
    return {
      apiService: new ApiService(),
      costs: [],
      total: 0,
      loading: false,
      page: 1,
      totalPages: 1,
    }
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `avoided_Cost_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/avoidedCost', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    list() {
      this.loading = true

      this.apiService
        .post('reports/listAvoidedCosts', this.filterProp)
        .then((response) => {
          this.costs = response.content.model.objects
          this.total = response.content.total

          this.totalPages = response.content.model.pager.totalPages
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    formatCurrency(value) {
      const stringValue = value.toFixed(2)
      const parts = stringValue.split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      return `$${parts.join(',')}`
    },
  },

  watch: {
    page() {
      this.filterProp.page = this.page
      this.list()
    },
  },
}
</script>

<style scoped></style>
